import {StyledFiltersBar} from '@components/ui/filters-bar/style.ts'
import {HTMLAttributes} from 'react'

export const FiltersBar = (props: HTMLAttributes<HTMLDivElement>) => <StyledFiltersBar {...props} />
